import React from 'react';
import { ButtonGroup, Typography } from 'components/ui';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { WhiteCard } from 'components/styles_components/card';
import { DividerContainer } from 'components/styles_components/container';
import ProfileQuery from 'queries/user/profile';
import ShowItemRow from 'components/item/show_item_row';
import Loader from 'components/loader';
import Boolean from 'components/boolean';
import EditButton from 'components/user/profile/button/edit';
import DeleteButton from 'components/user/profile/button/delete';

const Show = () => {
  const setError = useError();
  const {
    data = { user: {} },
    loading,
    refetch,
  } = useQuery(ProfileQuery, {
    onError: () => {
      setError('error.user.profile.show');
    },
  });

  if (loading) {
    return <Loader />;
  }

  return (
      <>
      <WhiteCard>
        <Typography variant="h5">
          <FormattedMessage id="user.personal_info" />
        </Typography>
        <Typography variant="body2" gutterBottom>
          <FormattedMessage id="user.personal_info.description" />
        </Typography>
        <DividerContainer />
        <ShowItemRow label={<FormattedMessage id="user.firstname" />}>{data.user.name}</ShowItemRow>
        <ShowItemRow label={<FormattedMessage id="user.surname" />}>{data.user.surname}</ShowItemRow>
        <ShowItemRow label={<FormattedMessage id="user.email" />}>{data.user.email}</ShowItemRow>
        <ShowItemRow label={<FormattedMessage id="settings.send_email_notifications" />}>
          <Boolean value={data.user.sendEmailNotificationsSetting} />
        </ShowItemRow>
        <ButtonGroup>
          <EditButton user={data.user} refetch={refetch} />
        </ButtonGroup>
      </WhiteCard>
      <WhiteCard>
        <Typography variant="h5">
          <FormattedMessage id="user.remove_account" />
        </Typography>
        <Typography variant="body2" gutterBottom>
          <FormattedMessage id="user.remove_account_description" />
        </Typography>
        <ButtonGroup>
          <DeleteButton />
        </ButtonGroup>
      </WhiteCard>
    </>
  );
};

export default Show;
